import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { WINDOW } from 'ngx-window-token';
import { ENVIRONMENT } from '@flexbenefits-ui/data-access-api';
import { catchError, map, of } from 'rxjs';

export const authGuard: CanActivateFn = () => {
    const environment = inject(ENVIRONMENT);
    const win = inject(WINDOW) as Window;
    const http = inject(HttpClient);

    if (environment.features?.['enableMockData'] || win.location.hostname === 'localhost') {
        return true;
    }

    // YF_SSID is an HttpOnly cookie — not readable via document.cookie.
    // Verify the session by probing the userInfo endpoint; the browser will
    // automatically include the HttpOnly cookie in the request.
    return http
        .get(environment.userInfoApiUrl, { withCredentials: true })
        .pipe(
            map(() => true),
            catchError(() => {
                const loginUrl = environment.loginUrl ?? '';
                const homeUrl = environment.homeUrl ?? '';
                win.location.href = `${loginUrl}?returnUrl=${encodeURIComponent(homeUrl)}`;
                return of(false);
            })
        );
};